import { useId } from "react";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import { MapCenterControl } from "./MapCenterControl";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({ iconRetinaUrl: markerIcon2x, iconUrl: markerIcon, shadowUrl: markerShadow });

export default function MiniMap({ lat, lng, height = 160, testId, interactive = false }) {
  const instanceId = useId();
  const mapId = testId || `mini-map-${instanceId.replace(/[^a-zA-Z0-9-]/g, "")}`;
  if (lat == null || lng == null) return null;
  return (
    <div data-testid={mapId} onDragStart={(event) => event.stopPropagation()} className="rounded-md overflow-hidden border border-slate-700/60" style={{ height }}>
      <MapContainer
        center={[lat, lng]}
        zoom={14}
        scrollWheelZoom={interactive}
        dragging={interactive}
        zoomControl
        doubleClickZoom={interactive}
        touchZoom={interactive}
        attributionControl={false}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Marker position={[lat, lng]} />
        <MapCenterControl pins={[{ lat, lng }]} testId={mapId} />
      </MapContainer>
    </div>
  );
}
